import { methodResult, post } from "./api.js";
import { config, labels } from "./config.js";
import {
	setActionLabel,
	setBusy,
	showFieldError,
	showNotice,
	validateEmail,
} from "./components.js";

export function initForgotPassword() {
	const form = document.querySelector("[data-auth-forgot-form]");
	if (!form) return;
	const email = form.elements.email;
	let googleEmail = "";

	email.addEventListener("input", () => {
		googleEmail = "";
		setActionLabel(form, labels.sendResetLink);
		showNotice(form, "");
	});
	form.addEventListener("submit", async (event) => {
		event.preventDefault();
		showNotice(form, "");
		const emailError = validateEmail(email);
		if (emailError) {
			showFieldError(email, emailError);
			return;
		}
		const candidate = email.value.trim().toLowerCase();
		if (googleEmail === candidate && config.googleUrl) {
			location.assign(config.googleUrl);
			return;
		}
		setBusy(form, true, labels.checkingEmail);
		try {
			const resolutionPayload = await post(
				"/api/method/syscofy_core.api.web_auth_registration.resolve_email_authentication",
				{ email: candidate },
			);
			const resolution = methodResult(resolutionPayload);
			if (!resolution?.ok) {
				showNotice(form, resolution?.error?.message || labels.requestFailed);
				return;
			}
			if (resolution.status === "existing_user" && resolution.auth_method === "google") {
				googleEmail = candidate;
				setActionLabel(form, labels.continueGoogle);
				showNotice(form, resolution.message, "success");
				return;
			}
			if (["registration_pending", "disabled_user"].includes(resolution.status)) {
				showNotice(form, resolution.message);
				return;
			}
			await post("/api/method/frappe.core.doctype.user.user.reset_password", {
				user: candidate,
			});
			showNotice(form, labels.resetSent, "success");
		} catch (error) {
			showNotice(form, error.status === 429 ? labels.tooManyRequests : labels.requestFailed);
		} finally {
			setBusy(form, false, labels.checkingEmail);
		}
	});
}
